import React from "react";
import { withRouter } from "react-router-dom";

import Sidebar from "../../containers/SupportChat/sideBar";
import Chat from "../../containers/SupportChat/chat";
import {  getChats, getChatMsg } from "../../apiRoutes";
import MakeAPICall from "../../apiCalls/common";

import _ from "lodash";

import socket from "../../utils/socket";

class SupportChatPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      apiCallParams: null,
      chatList: [],
      currentDoctorChat: null,
      chatMessage: null
    };
  }

  componentDidMount() {
    this.getChats();
    //this.getChatMsg();

    // call this api to make doctor online/offline status updates
    // this.chatInerval = setInterval(() => {
    //   this.getChatsV2();
    // }, 10000);

    socket.on('DOCTOR_QUEUE_DATA', (data) => {
      console.log("Emit event for doctors: ", data);
    });

    socket.on("adminReadAllMsg", this.updateMessageCount);
    socket.on("doctorMessageDone", this.updateDoctorMsgCount);
  }

  componentWillMount() {
    clearInterval(this.chatInerval);
  }

  getChats = () => {
    let apiCallObj = {
      reqType: "GET",
      reqUrl: getChats,
      params: {},
      successCallback: async res => {
        if (res.data.data.data.length) {
          this.setState({
            chatList: res.data,
            currentDoctorChat: res.data.data.data[0]
          });
          this.getCurrentDocChat(res.data.data.data[0]);
        }
      },
      failureCallback: err => {
        console.log("Got some error here : ", err);
      }
    };

    this.setState({
      apiCallParams: apiCallObj
    });
  };

  
  // getChatsV2 = () => {
  //   let apiCallObj = {
  //     reqType: "GET",
  //     reqUrl: getChats,
  //     params: {},
  //     successCallback: async res => {
  //       if (res.data.data.data.length) {
  //         this.setState({
  //           chatList: res.data
  //         });
  //       }
  //     },
  //     failureCallback: err => {
  //       console.log("Got some error here : ", err);
  //     }
  //   };

  //   this.setState({
  //     apiCallParams: apiCallObj
  //   });
  // };

  getCurrentDocChat = data => {
    let apiCallDoctChat = {
      reqType: "GET",
      reqUrl: getChatMsg,
      params: {
        doctorId: data.doctorId._id,
        limit: 10
      },
      successCallback: async res => {
        this.setState({
          chatMessage: res.data.data
        });
      },
      failureCallback: err => {
        console.log("Got some error : ", err);
      }
    };
    this.setState({
      apiCallParams: apiCallDoctChat
    });
  };

  updateMessageCount = data => {
    if (data.status) {
      let copyArray = JSON.parse(JSON.stringify(this.state.chatList));
      let chatIndex = -1;
      try {
        chatIndex = _.findIndex(copyArray.data.data, function(o) {
          return o._id === data.chatId;
        });
      } catch (e) {
        console.log("Error : ", e);
      }
      if (chatIndex > -1) {
        copyArray.data.data[chatIndex].practitionerCount = 0;
        this.setState({
          chatList: copyArray
        });
      }
    }
  };

  updateDoctorMsgCount = data => {
    try {
      if (data.status) {
        let copyArray = JSON.parse(JSON.stringify(this.state.chatList));
        let chatIndex = _.findIndex(copyArray.data.data, function (o) {
          return o._id === data.data.chatId;
        });
        if (chatIndex > -1) {
          copyArray.data.data[chatIndex].practitionerCount =
            copyArray.data.data[chatIndex].practitionerCount + 1;
          this.setState({
            chatList: copyArray
          });
        }
      }
    } catch (e) {
      console.log("Something went wrong during msg update: ", data, e);
    }
  };

  openDocChat = data => {
    this.setState({
      currentDoctorChat: data
    });
    this.getCurrentDocChat(data);
  };

  updateChatList = () => {
    this.getCurrentDocChat(this.state.currentDoctorChat);
  };

  updateSideDocChatList = () => {
    this.getChats();
   
  };

  render() {
    return (
      <div className="row support-chat-container pt-3">
        <div className="col-md-3">
          <Sidebar
            chatList={this.state.chatList}
            openChat={this.openDocChat}
            updateChatCount={this.updateChatCount}
            updateSideChatList={this.updateSideDocChatList}
          />
        </div>
        <div className="col-md-9">
          <Chat
            currentDoctorChat={this.state.currentDoctorChat}
            chatMessage={this.state.chatMessage}
            updateChatList={this.updateChatList}
            updateNewDocChat={this.updateSideDocChatList}
          />
        </div>
        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCallParams} />
      </div>
    );
  }
}

export default withRouter(SupportChatPage);
